<template>
  <el-card class="my-box-card">
    <div style="height: 30px;">
      <el-input size="small" placeholder="姓名" style="width: 220px;float: left" v-model="formParam.name"></el-input>
      <el-button size="small" type="info" plain style="margin-left: 10px;float: left" @click="handleSearch">搜索</el-button>
      <el-button v-if="isManager" size="small" type="primary" plain style="float: right;" @click="handleAdd">新增</el-button>
    </div>
    <el-alert
      type="warning"
      style="margin: 15px 0;"
      show-icon>
      <span>您有<span style="font-size: 18px;font-weight: bold;padding: 0 5px;">{{totalVips}}</span>个可分配会员！</span>
    </el-alert>
    <el-table
      :data="tableData"
      v-loading="loadingTable"
      style="width: 100%">
      <el-table-column
        prop="account"
        label="账号"
        width="120">
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        width="100">
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号码">
      </el-table-column>
      <el-table-column
        prop="vipEdate"
        label="会员到期日">
        <template slot-scope="scope">
          <span>{{scope.row.vipEdate| dateToStr}}</span>
          <span>{{scope.row.vipEdate|toVipEdate}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isManager"
        label="角色"
        width="100">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.isManager === '0'">管理员</el-tag>
          <el-tag type="info" v-if="scope.row.isManager === '1'">普通</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        width="90">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status === '0'">启用</el-tag>
          <el-tag type="danger" v-if="scope.row.status === '1'">停用</el-tag>
        </template>
      </el-table-column>
      <!--<el-table-column
        prop="date"
        label="创建时间">
      </el-table-column>-->
      <el-table-column
        label="操作"
        v-if="isManager"
        width="180"
        align="center">
        <template slot-scope="scope">
          <!--<el-button type="text" v-if="scope.row.isManager !== '0'" @click="handleView(scope.row)">查看</el-button>-->
          <el-button type="text" size="mini" v-if="!scope.row.vipEdate" @click="handleSetVip(scope.row)">设为会员</el-button>
          <el-button type="text" size="mini" v-if="scope.row.vipEdate" @click="handleSetVip(scope.row)">会员续费</el-button>
          <el-button v-if="scope.row.status === '0' && scope.row.isManager !== '0'" @click="handleFreezeUser(scope.row)" size="mini" type="text" >冻结</el-button>
          <el-button v-if="scope.row.status === '1' && scope.row.isManager !== '0'" @click="handleThawUser(scope.row)" size="mini" type="text" >启用</el-button>
          <el-popconfirm
            confirm-button-text='确定'
            cancel-button-text='取消'
            icon="el-icon-info"
            style="margin-left: 5px;"
            @confirm="handleDelete(scope.row)"
            icon-color="red"
            title="确定删除该账号吗？"
          >
            <el-button slot="reference" size="mini" type="text" v-if="scope.row.isManager !== '0'" >删除</el-button>
          </el-popconfirm>
          <el-popconfirm
            confirm-button-text='转让'
            style="margin-left: 5px;"
            cancel-button-text='取消'
            @confirm="handleSetUserManage(scope.row)"
            title="确定转让管理员吗？"
          >
            <el-button slot="reference" size="mini" type="text" v-if="scope.row.isManager !== '0'">转让管理员</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-bind:child-msg="pageParam" @callFather="callFather"></pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" v-if="editFormVisible" :destroy-on-close="true"
               width="60%" @click="closeDialog" center
               :close-on-click-modal="false"
               :close-on-press-escape="false" append-to-body>
      <stuff-edit ref="editDialog" :edit="editForm"></stuff-edit>
      <div slot="footer" class="dialog-footer" v-if="editForm.pageType !== 'view'">
        <el-button type="primary" :loading="loading" class="title" @click="handleSave">保存</el-button>
        <el-button @click="closeDialog">取消</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-if="editForm.pageType === 'view'">
        <el-button @click="closeDialog">返回</el-button>
      </div>
    </el-dialog>
    <!--设置会员-->
    <el-dialog title="会员设置" :visible.sync="vipFormVisible" v-if="vipFormVisible" :destroy-on-close="true"
               width="40%" @click="closeDialog" center
               :close-on-click-modal="false"
               :close-on-press-escape="false" append-to-body>
      <el-alert
        type="warning"
        show-icon>
        <span v-if="totalVips === 0">您没有可分配会员！<my-link style="color: #32A08C;text-decoration: none" type="primary" href="/userCenter/vipLevel"> 去充值 </my-link></span>
        <span v-if="totalVips > 0">您有<span style="font-size: 18px;font-weight: bold;padding: 0 5px;">{{totalVips}}</span>个可分配会员！</span>
      </el-alert>
      <el-table
        :data="vipOrders"
        style="width: 100%">
        <el-table-column
          prop="createTime"
          width="160"
          label="下单日期">
          <template slot-scope="scope">
            {{scope.row.createTime|dateToStr}}
          </template>
        </el-table-column>
        <el-table-column
          prop="month"
          label="会员周期（月）">
        </el-table-column>
        <el-table-column
          prop="remainingNumber"
          label="剩余数量">
          <template slot-scope="scope">
            <span v-if="templateRadio === scope.row.id">
              {{scope.row.remainingNumber -1}}（{{scope.row.remainingNumber}}<span style="color: red"> -1 </span>）
            </span>
            <span v-else>{{scope.row.remainingNumber}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="选择会员"
          align="center"
          width="140">
          <template slot-scope="scope">
            <el-radio :label="scope.row.id" v-model="templateRadio"
                      @change.native="getTemplateRow(scope.$index,scope.row)">选择
            </el-radio>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="currUser.vipEdate" style="margin-top: 30px;">
        为 <span style="font-size: 14px;font-weight: bold;">{{currUser.account}}（{{currUser.name}}）</span> 会员续费?（一旦续费，不可取消）
        <el-button type="warning" style="margin-left: 15px;" size="mini" :loading="loading"  @click="handleSaveVip">确定</el-button>
      </div>
      <div v-if="!currUser.vipEdate" style="margin-top: 30px;">
        将 <span style="font-size: 14px;font-weight: bold;">{{currUser.account}}（{{currUser.name}}）</span> 设置为会员?（一旦设置，不可取消）
        <el-button type="warning" style="margin-left: 15px;" size="mini" :loading="loading"  @click="handleSaveVip">确定</el-button>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { list, addUser, deleteUser, thawUser, freezeUser, setUserManage } from '@/api/user/user'
import stuffEdit from './edit/stuffEdit.vue'
import { getLists as vipOrderLists, setVip } from '@/api/user/userVip'

export default {
  components: { stuffEdit },
  name: 'myInvoice',
  data () {
    return {
      title: '',
      tableData: [],
      editFormVisible: false,
      vipFormVisible: false,
      isManager: false,
      loadingTable: false,
      loading: false,
      isDisabled: false,
      templateRadio: '',
      vipOrders: [],
      pageParam: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      currUser: {},
      formParam: {},
      totalVips: 0,
      editForm: {}
    }
  },
  computed: {
    user () {
      return this.$store.state.user.userInfo
    },
    companyInfo () {
      return this.$store.state.user.companyInfo
    },
    isLogin () {
      return this.$store.state.user.isLogin
    }
  },
  mounted () {
    if (this.user.isManager === '0') {
      this.isManager = true
    } else {
      this.isManager = false
    }
    this.handleSearch()
    this.getVipOrderLists()
  },
  filters: {
    toVipEdate: function (edate) {
      if (edate) {
        var diff = Math.abs(edate - new Date().getTime())
        var diffday = parseInt(diff / (1000 * 60 * 60 * 24))
        if (diffday < 10) {
          return '即将过期'
        }
        return ''
      } else {
        return '非会员'
      }
    }
  },
  methods: {
    getTemplateRow (index, row) {
      this.templateSelection = row
      this.tableData.forEach((row, index) => {
        row.enableFlag = this.templateSelection.id
      })
      row.enableFlag = ''
    },
    handleSearch () {
      this.formParam.page = {
        pageNum: this.pageParam.currentPage,
        pageSize: this.pageParam.pageSize,
        orderBy: 'createTime'
      }
      this.mockTableData()
    },
    mockTableData () {
      this.loadingTable = true
      list(this.formParam).then(res => {
        this.loadingTable = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.tableData = result.bizData
          this.pageParam.total = result.total
        }
      }).catch(ex => {
        this.loadingTable = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    },
    // 新增
    handleAdd () {
      this.title = '新增员工信息'
      this.editForm = {}
      this.editForm.status = 0
      this.editForm.pageType = 'add'
      this.editFormVisible = true
    },
    handleEdit (row) {
      this.title = '编辑员工信息'
      this.editForm.id = row.id
      this.editForm.account = row.account
      this.editForm.name = row.name
      this.editForm.mobile = row.mobile
      this.editForm.mailBox = row.mailBox
      this.editForm.password = row.password
      if (row.status !== null) {
        this.editForm.status = Number(row.status)
      }
      if (row.isManager !== null) {
        this.editForm.isManager = Number(row.isManager)
      }
      this.editForm.pageType = 'edit'
      this.editFormVisible = true
    },
    handleView (row) {
      this.title = '查看员工信息'
      this.editForm.id = row.id
      this.editForm.account = row.account
      this.editForm.name = row.name
      this.editForm.mobile = row.mobile
      this.editForm.mailBox = row.mailBox
      this.editForm.password = row.password
      if (row.status !== null) {
        this.editForm.status = Number(row.status)
      }
      if (row.isManager !== null) {
        this.editForm.isManager = Number(row.isManager)
      }
      this.editForm.pageType = 'view'
      this.editFormVisible = true
    },
    getVipOrderLists () {
      vipOrderLists().then(res => {
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.vipOrders = result.bizData
          if (this.vipOrders && this.vipOrders.length > 0) {
            this.totalVips = 0
            this.vipOrders.forEach(v => {
              this.totalVips = this.totalVips + v.remainingNumber
            })
            this.templateRadio = this.vipOrders[0].id
          }
        }
      }).catch(ex => {
        this.$message.error('获取会员订单列表失败，请稍后再试！')
      })
    },
    // 设置会员
    handleSetVip (row) {
      this.currUser = row
      this.vipFormVisible = true
    },
    handleSaveVip () {
      let param = {}
      param.orderId = this.templateRadio
      param.userId = this.currUser.id
      setVip(param).then(res => {
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.vipFormVisible = false
          this.handleSearch()
        }
      }).catch(ex => {
        this.$message.error('设置会员失败，请稍后再试！')
      })
    },
    // 删除
    handleDelete (row) {
      this.editForm.id = row.id
      var params = { ids: [] }
      params.ids.push(this.editForm.id)
      deleteUser(params).then(res => {
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.handleSearch()
        }
      }).catch(ex => {
        this.$message.error('删除员工信息失败，请稍后再试！')
      })
    },
    // 冻结
    handleFreezeUser: function (row) {
      let params = {}
      params.userId = row.id
      freezeUser(params).then(res => {
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.handleSearch()
        }
      }).catch(ex => {
        this.loading = false
      })
    },
    // 解冻
    handleThawUser: function (row) {
      let params = {}
      params.userId = row.id
      thawUser(params).then(res => {
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.handleSearch()
        }
      }).catch(ex => {
        this.loading = false
      })
    },
    // 转让管理员
    handleSetUserManage: function (row) {
      let params = {}
      params.userId = row.id
      setUserManage(params).then(res => {
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.handleSearch()
          this.$router.go(0)
        }
      }).catch(ex => {
        this.loading = false
      })
    },
    // 保存
    handleSave () {
      if (this.isDisabled) {
        return false
      }
      this.isDisabled = true
      const formBody = this.$refs['editDialog'].editForm
      formBody.companyId = this.user.companyId
      this.$refs['editDialog'].$refs['editForm'].validate(valid => {
        if (valid) {
          addUser(formBody).then(response => {
            this.isDisabled = false
            const result = response.data
            if (result.rtnCode === '0') {
              this.editFormVisible = false
              this.handleSearch()
            } else {
              this.$message({
                type: 'info',
                message: '新增员工信息失败，' + result.msg
              })
            }
          }).catch(ex => {
            this.isDisabled = false
            this.$message('新增员工信息失败，请稍后再试！')
          })
        } else {
          this.isDisabled = false
          return false
        }
      })
    },
    // 分页插件事件
    callFather (parm) {
      this.pageParam.currentPage = parm.currentPage
      this.pageParam.pageSize = parm.pageSize
      this.handleSearch()
    },
    closeDialog () {
      this.vipFormVisible = false
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>

</style>
